var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paginations"},[_c('el-pagination',{attrs:{"current-page":_vm.innerCurrentPage,"page-size":_vm.size,"total":_vm.total,"layout":"prev, pager, next, jumper"},on:{"size-change":function($event){return _vm.$emit('size-change', $event)},"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }